import React from 'react';
import PGxReports from 'components/business/PGxReports';

export const ReportsCtx = React.createContext({});

function ReportsPageProvider(props) {
  const ctx = {};

  return (
    <ReportsCtx.Provider value={ ctx }>
      {props.children}
    </ReportsCtx.Provider>
  );
}

function PGxReportsPage() {
  return (
    <ReportsPageProvider>
      <PGxReports />
    </ReportsPageProvider>
  );
}

export default PGxReportsPage;
